import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AutocompleteTableFilter, clearField, getError, SmartFormContainer } from '@shared';
import {
  finalize,
  Observable,
  Subscription,
} from 'rxjs';
import { AppInjector } from '@app';

@Component({
  selector: 'app-autocomplete-filter',
  templateUrl: './autocomplete-filter.component.html',
  styleUrls: ['./autocomplete-filter.component.scss'],
})
export class AutocompleteFilterComponent extends SmartFormContainer implements OnInit, OnDestroy {
  readonly getError = getError;
  readonly clearField = clearField;

  autocompleteList: any[];
  autocompleteSubscription: Subscription = null;
  filterQuery$: Observable<string>;
  autocompleteListEmpty: boolean;
  autocompleteListLoading: boolean = false;
  private _autocompleteTooltip: string;

  get autocompleteTooltip(): string {
    return this._autocompleteTooltip;
  }

  set autocompleteTooltip(text: string) {
    this._autocompleteTooltip = text;
  }

  @Input() config: AutocompleteTableFilter;

  ngOnInit(): void {
    if (this.config.initOnFocus) {
      return;
    } else {
      this.initSubscription();
    }
    this.filterQuery$ = this.config.filterQuery ? this.config.filterQuery(this.form) : null;
  }

  focus(): void {
    if (!this.config.initOnFocus) {
      return;
    } else {
      this.initSubscription();
    }
  }

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  get tooltip(): string {
    return this.config.tooltipCallback
      ? this.config.tooltipCallback(this.form)
      : this.autocompleteTooltip;
  }

  initSubscription(): void {
    if (this.autocompleteSubscription) {
      return;
    }

    this.autocompleteSubscription = this.config.valueChangeSubscription(this);
  }

  getListSubscription(value: string): Observable<any> {
    this.autocompleteListLoading = true;
    return AppInjector.get(this.config.service)[this.config.methodName](value)
      .pipe(finalize(() => this.autocompleteListLoading = false));
  }

  ngOnDestroy(): void {
    this.autocompleteSubscription?.unsubscribe();
  }
}
